<div class="prime-card">
    <div class="decorative-shape-top"></div>
    <div class="decorative-shape-back"></div>
    <img class="prime-card-glow-top" src="assets/svg/icons/glow.svg" />
    <form [formGroup]="dgLockerConsentForm">
        <div class="prime-card-wrapper">
            <header class="prime-card-header">
                <div class="header-back">
                    <ng-container *ngTemplateOutlet="backButtonTemplate"></ng-container>
                </div>
                <div class="step-indicator step-indicator-w40">
                    <div class="indicator-bar active"></div>
                    <div class="indicator-bar"></div>
                </div>

                <div class="header-content-center">
                    <h3 class="header-title-gradient">Verify your Aadhaar & PAN details</h3>
                    <p class="fs-md text-primary-50">We use DigiLocker to verify your Aadhaar and PAN details.</p>
                </div>
            </header>
            <section class="prime-card-body">
                <div class="content-wrapper-bottom mt-auto">
                    <div class="checkbox-card prime-subcard">
                        <mat-checkbox formControlName="isAgreed" class="checkbox-label-md">
                            By clicking on “I agree” you authorise Klinq to fetch your Aadhaar and PAN details from
                            DigiLocker
                        </mat-checkbox>
                    </div>
                </div>
            </section>

            <div class="prime-card-footer">
                <div class="prime-card-footer-left">
                    <ng-container *ngTemplateOutlet="backButtonTemplate"></ng-container>
                </div>
                <div class="prime-card-footer-right">
                    <button
                        type="button"
                        class="primary-fill-btn"
                        [disabled]="!dgLockerConsentForm.valid"
                        (click)="startKyc()"
                    >
                        I Agree <img src="assets/svg/icons/arrow-right-up.svg" alt="arrow-right-up" />
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
<ng-template #backButtonTemplate>
    <button type="button" class="back-btn back-outline-btn" [routerLink]="'/loan/aadhaar-kyc'">
        <img class="back-btn-icon" src="assets/svg/icons/chevron-back.svg" alt="" />
        <span class="back-btn-text">Back</span>
    </button>
</ng-template>
